export const DE = 'de'
export const EN = 'en'

export const locales = [DE, EN]